<div class="pagination pagination-ball">
  <span [ngClass]="{'is-active': screenStage == 1}"></span>
  <span [ngClass]="{'is-active': screenStage == 2}"></span>
  <span [ngClass]="{'is-active': screenStage == 3}"></span>
  <span [ngClass]="{'is-active': screenStage == 4}"></span>
  <span [ngClass]="{'is-active': screenStage == 5}"></span>
  <span [ngClass]="{'is-active': screenStage == 6}"></span>
</div>